import React, { useEffect, useState } from "react";
import { Styles } from "./styles";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../api_Routes";
import { useNavigate, useParams } from "react-router-dom";
import ChatComponent from "./chat-component";
import { Box, CircularProgress } from "@mui/material";
import { useSnackbar } from "notistack";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {useCenteredSnackbar} from "../../../tools/useCenteredSnackbar";

const TicketsChat = () => {
  const { id } = useParams();
  const { enqueueSnackbar,closeSnackbar } = useSnackbar();
  const { showCenteredPopup } = useCenteredSnackbar();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isSendLoading, setIsSendLoading] = useState(false);
  const [data, setData] = useState([]);
  const [status, setStatus] = useState("");


  const action = key => (
      <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={() => closeSnackbar(key)}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
  );
  const getData = async () => {
    const { response, message } = await Helper.Get({
      url: api_Routes.dashboard.tickets.viewTicket + id,
      hasToken: true,
    });
    if (response) {
      setData(response.data.messages);
      setStatus(response.data.ticket_status);
    } else {
      showCenteredPopup("Can't find this ticket",
          { variant: "error",
            persist: true });
      // enqueueSnackbar("Can't find this ticket", { variant: "error",
      //   persist: true,
      //   action, });
      navigate("/dashboard/tickets");
    }
    setIsLoading(false);
    setIsSendLoading(false);
  };

  useEffect(() => {
    getData();

    const interval = setInterval(() => {
      getData();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  return isLoading ? (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "calc(100dvh - 92px)",
      }}
    >
      <CircularProgress sx={{ color: "blue" }} />
    </Box>
  ) : (
    <Styles>
      <div className="title">Ticket #{id}</div>
      <ChatComponent
        status={status}
        data={data}
        getData={getData}
        isSendLoading={isSendLoading}
        setIsSendLoading={setIsSendLoading}
      />
    </Styles>
  );
};

export default TicketsChat;
